import React from 'react';
import { useTranslation } from 'react-i18next';
import { TruncatedText, TruncationMode } from 'components/TruncatedText';
import {
  AdditionalSection,
  AdditionalSectionTitle,
  AdditionalSectionContent,
  HeadingAdditional,
} from './styles';

interface AdditionalReminderSectionProps {
  containsRemindersText: boolean;
  experience: {
    healthAndSafety: string;
  };
}

const AdditionalReminderSection: React.FC<AdditionalReminderSectionProps> = ({
  containsRemindersText,
  experience,
}) => {
  const { t } = useTranslation();
  if (!containsRemindersText) {
    return null;
  }
  return (
    <AdditionalSection>
      <AdditionalSectionTitle>
        <HeadingAdditional className="experience-view__reminders-title">
          {t('reminders')}
        </HeadingAdditional>
      </AdditionalSectionTitle>
      <AdditionalSectionContent>
        <TruncatedText
          text={experience.healthAndSafety}
          isRichText
          mode={TruncationMode.INLINE}
        />
      </AdditionalSectionContent>
    </AdditionalSection>
  );
};

export default AdditionalReminderSection;
